import React from 'react';

import { getUserUrl } from '../../helpers/urls';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';

interface IProps {
  userTag: string;
}

const constructUserParameter = (userTag: string): string => {
  return userTag.trim().substring(1);
};

export const TagUser = ({ userTag }: IProps) => {
  return <InternalLink to={getUserUrl(constructUserParameter(userTag))}>{userTag}</InternalLink>;
};
